import {
  Alert, Box, Button, Grid, LinearProgress, Typography,
} from '@mui/material';
import { Form } from '@unform/web';
import InputCustom from 'Shared/Components/Form/InputReactCustom';

// import * as Yup from 'yup';
import { ISuppliersReportFilters, ISuppliersReportPage } from '../../Interface';
import React from 'react';

function SuppliersReportFilterFormPage(props: ISuppliersReportPage) {
  const formDefault = React.useRef<any>(null);
  const [buttonLoading, setButtonLoading] = React.useState<{ search: boolean, clear: boolean }>({ search: false, clear: false });
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

  const [initialData, setInitialData] = React.useState<ISuppliersReportFilters>({
    codigo: props.filters.codigo,
    nome: props.filters.nome,
    documento: props.filters.documento,
    active: 'Todos' //props.filters.active
  });

  // const schema = Yup.object().shape({
  //   nome: Yup.string(),
  //   documento: Yup.string(),
  //   codigo: Yup.string(),
  //   email: Yup.string().email(),
  //   active: Yup.string(),
  // });

  const toggleButtonLoading = (key: 'search' | 'clear', value: boolean) => {
    setButtonLoading(prev => ({ ...prev, [key]: value }));
  };

  const handleCleanFilters = async () => {
    setErrorMessage(null);
    toggleButtonLoading('clear', true);
    const _filters: ISuppliersReportFilters = { codigo: '', nome: '', documento: '', active: props.filters.active };
    props.toggleChangeState('filters', _filters);
    toggleButtonLoading('clear', false);
  }

  const handleSubmit = async (data: any) => {
    setErrorMessage(null);
    toggleButtonLoading('search', true);
    const _filters: ISuppliersReportFilters = {
      codigo: data.codigo,
      nome: data.nome.toUpperCase(),
      documento: data.documento,
      active: data.active,
    };
    try {
      if (props.toggleGetSuppliersReport) {
        await Promise.resolve(props.toggleGetSuppliersReport(_filters));
      }
    } catch (error: any) {
      const message = error?.message || 'Não foi possível concluir a ação.';
      setErrorMessage(message);
    } finally {
      toggleButtonLoading('search', false);
    }
  };

  React.useEffect(() => {
    setInitialData(props.filters);
    if (formDefault.current) {
      formDefault.current.setFieldValue('codigo', props.filters.codigo);
      formDefault.current.setFieldValue('nome', props.filters.nome);
      formDefault.current.setFieldValue('documento', props.filters.documento);
      formDefault.current.setFieldValue('active', props.filters.active);
    }
  }, [props.filters, props.dateUpdateInfo])

  return (
    <Box id="SuppliersReport" key="SuppliersReport" className="FormRoot" data-label={props.dateUpdateInfo}>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography component="div" align="justify">
            <Box id="SuppliersReportFilterForm" key="SuppliersReportFilterForm">
              <Form
                ref={formDefault}
                id="myFormDefault"
                name="myFormDefault"
                onSubmit={handleSubmit}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
                    <Typography component="div" align="left">
                      <InputCustom
                        autoComplete="off"
                        handleChangeCustom={() => { }}
                        disabled={false}
                        classCustom="FormInput FormInput100"
                        defaultValue={initialData.codigo}
                        id="codigo"
                        name="codigo"
                        label="Código"
                        type="text" />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <Typography component="div" align="left">
                      <InputCustom
                        autoComplete="off"
                        handleChangeCustom={() => { }}
                        disabled={false}
                        classCustom="FormInput FormInput100"
                        defaultValue={initialData.nome}
                        id="nome"
                        name="nome"
                        label="Nome"
                        type="text"
                      />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <Typography component="div" align="left">
                      <InputCustom
                        autoComplete="off"
                        handleChangeCustom={() => { }}
                        disabled={false}
                        classCustom="FormInput FormInput100"
                        defaultValue={initialData.documento}
                        id="documento"
                        name="documento"
                        label="Documento"
                        type="text"
                      />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
                    <Typography component="div" align="left">
                      <InputCustom
                        autoComplete="off"
                        handleChangeCustom={() => { }}
                        disabled={true}
                        classCustom="FormInput FormInput100"
                        defaultValue={initialData.active}
                        id="active"
                        name="active"
                        label="Ativo"
                        type="text"
                      />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <Typography component="div" align="right">
                      <Button
                        variant="contained"
                        color="success"
                        className="ButtonPrimary"
                        type="submit"
                        disabled={buttonLoading.search}
                      >
                        <span>Pesquisar</span>
                      </Button>
                      {buttonLoading.search && (
                        <Box mt={1}>
                          <LinearProgress />
                        </Box>
                      )}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <Typography component="div" align="right">
                      <Button
                        variant="contained"
                        color="success"
                        className="ButtonDefault"
                        type="button"
                        onClick={handleCleanFilters}
                        disabled={buttonLoading.clear}
                      >
                        <span>Limpar filtros</span>
                      </Button>
                      {buttonLoading.clear && (
                        <Box mt={1}>
                          <LinearProgress color="secondary" />
                        </Box>
                      )}
                    </Typography>
                  </Grid>
                </Grid>
                <span>&nbsp;</span>
              </Form>
              {errorMessage && (
                <Box mt={2}>
                  <Alert severity="error" onClose={() => setErrorMessage(null)}>
                    {errorMessage}
                  </Alert>
                </Box>
              )}
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SuppliersReportFilterFormPage;
